export enum FunctionsNames {
  sendOTP = 'sendOTP',
  signUp = 'signUp',
  bindUserToAgent = 'bindUserToAgent',
  confirmEmail = 'confirmEmail',
  deleteAgent = 'deleteAgent',
  deleteFirebaseUser = 'deleteFirebaseUser',
  updateUserLoginEmail = 'updateUserLoginEmail',
  findAgentDbIdByLoginEmail = 'findAgentDbIdByLoginEmail',
  updateSalesGoals = 'updateSalesGoals',
  validateOTP = 'validateOTP',
  updateUserPassword = 'updateUserPassword',
  elasticSearch = 'elasticSearch',
  elasticSearchGen2 = 'elasticSearchGen2',
  uploadMedia = 'uploadMedia',
  createTempUploadSession = 'createTempUploadSession',
  getMedia = 'getMedia',
  deleteMedia = 'deleteMedia',
  getImageContentByUrl = 'getImageContentByUrl',
  updateAgentCampaignsIssuesStatistics = 'updateAgentCampaignsIssuesStatistics',
  getArchivedImages = 'getArchivedImages',
  collectPaymentIntent = 'collectPaymentIntent',
  processPayment = 'processPayment',
  refundPayment = 'refundPayment',
  handleWebhookPayment = 'handleWebhookPayment',
  getPaymentEventListByTypes = 'getPaymentEventListByTypes',
  deleteConferenceRegistration = 'deleteConferenceRegistration',
  copyConferenceRegistration = 'copyConferenceRegistration',
  registrationSummaryEmail = 'registrationSummaryEmail',
  updateConferenceRegistrationLogStatistics = 'updateConferenceRegistrationLogStatistics',
  supportTaskEmailToAgent = 'supportTaskEmailToAgent',
  excursionsConfigurationsEmail = 'excursionsConfigurationsEmail',
  bulkEmailSending = 'bulkEmailSending',
  getAuthentication = 'getAuthentication',
  deleteAuthentication = 'deleteAuthentication',
  forceVerifyEmailAuthentication = 'forceVerifyEmailAuthentication',
  sendPushNotification = 'sendPushNotification',
  createCustomToken = 'createCustomToken',
  getStats = 'getStats',
  getFileUploadUrl = 'getFileUploadUrl',
  uploadFile = 'uploadFile',
  deleteWeekTransactions = 'deleteWeekTransactions',
  parseMSGFile = 'parseMSGFile',
  /**
   * @deprecated Use the Reporting API endpoint POST /api/dashboard/import-agent-portal-paid-file instead.
   */
  importTransactionsSummariesToElastic = 'importTransactionsSummariesToElastic',
  deleteConference = 'deleteConference',
  getEventPublicInfo = 'getEventPublicInfo',
  forceChangeUserLoginEmail = 'forceChangeUserLoginEmail',
  checkLoginEmail = 'checkLoginEmail',
  handlePageBuilderEmailSending = 'handlePageBuilderEmailSending',
  sendEmailTemplate = 'sendEmailTemplate',
  shipDocumentToElastic = 'shipDocumentToElastic',
  createFormBuilderActionPayload = 'createFormBuilderActionPayload',
  checkAgentRegistrationState = 'checkAgentRegistrationState',
  reportingApi = 'reportingApi',
  reactReportingApi = 'reactReportingApi',
  reportingDbHealthCheck = 'reportingDbHealthCheck',
  reportingDbHealthCheckDetailed = 'reportingDbHealthCheckDetailed',
  processCarrierProductionRawFile = 'processCarrierProductionRawFile',
  processSupportingTableUpload = 'processSupportingTableUpload',
  processMasterDatasetRun = 'processMasterDatasetRun',
  reportingGridApi = 'reportingGridApi',
  reportingImportApi = 'reportingImportApi',
  registerMasterDatasetUpload = 'registerMasterDatasetUpload',
  loadMasterDatasetRuns = 'loadMasterDatasetRuns',
  recoverAgentBinding = 'recoverAgentBinding',
}
